import React from 'react'

export const NoMatch = () => {
    return (
        <div>
            <h1>No Match</h1>
        </div>
    )
}


